import { useQuery } from "@tanstack/react-query";
import { getGeneralReport, getOrders, getStatisticData } from "./api.js";
import { reactQueryCacheAndRefetchOptions } from "@";

// Query keys for React Query
export const statisticsKeys = {
  all: ["statistics"],
  statisticData: () => [...statisticsKeys.all, "statisticData"],
  generalReport: (params) => [...statisticsKeys.all, "generalReport", params],
  orders: (time) => [...statisticsKeys.all, "orders", time],
};

// Query hook for fetching statistics data
export const useStatisticDataQuery = () => {
  return useQuery({
    queryKey: statisticsKeys.statisticData(),
    queryFn: async () => await getStatisticData(),
    ...reactQueryCacheAndRefetchOptions,
  });
};

// Mutation hook for general report
export const useGeneralReportQuery = (params) => {
  return useQuery({
    queryKey: statisticsKeys.generalReport(params),
    queryFn: async () => await getGeneralReport(params),
    enabled: !!params, // Only run query if params are provided
    ...reactQueryCacheAndRefetchOptions,
  });
};

// Query hook for orders
export const useOrdersQuery = (time) => {
  return useQuery({
    queryKey: statisticsKeys.orders(time),
    queryFn: async () => await getOrders(time),
    enabled: !!time, // Only run query if time is provided
    ...reactQueryCacheAndRefetchOptions,
  });
};
